module.exports = __webpack_public_path__ + "static/media/ic_car.e895765b.svg";